import React from 'react'
import { Skeleton } from './skeleton'
import { TextSkeleton } from './text-skeleton'

export const FilterBoxSkeleton = () => {
  return (
    <Skeleton shade="light" height={600}>
      <div className="u-px-16 u-py-16">
        <TextSkeleton type="h3" />
        <TextSkeleton type="p" />
      </div>
    </Skeleton>
  )
}
